import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";

export const fetchAllFederalReligiousData = createAsyncThunk(
  "fetchAllFederalReligiousData",
  async () => {
    const result = await FetchRequestHandler("get", `${baseUrl}api/holidays`);
    console.log(result);

    return result;
  }
);

export const fetchDefaultFederalList = createAsyncThunk(
  "fetchDefaultFederalList",
  async (practiceId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/holidays`
    );

    return result;
  }
);

export const fetchUpdateDeletFederalList = createAsyncThunk(
  "fetchUpdateDeletFederalList",
  async ({ practiceId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/practices/${practiceId}/holidays`,
      data
    );
    return result;
  }
);
